import { r as registerInstance, h } from './index-5faac9d7.js';

const commercialStatusCss = ".commercial-status-label{display:inline-block;padding:5px 12px;border-radius:4px;color:#ffffff;font-size:14px;font-weight:700}";

const PesCommercialStatus = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.label = undefined;
    this.color = undefined;
  }
  render() {
    return (this.label
      && this.color && (h("div", { class: "commercial-status-label", style: { backgroundColor: this.color } }, this.label)));
  }
};
PesCommercialStatus.style = commercialStatusCss;

export { PesCommercialStatus as pes_commercial_status };
